import React from 'react';

import { IReactChildren } from '~/src/dash/types/props';
import { backgroundColor } from '~/src/dash/utils/material-dashboard-react';

export interface IBoxCenterProps extends IReactChildren {
  containerStyles?: any;
  innerStyles?: any;
}

export function BoxCenter({ containerStyles, innerStyles, children }: IBoxCenterProps) {
  return (
    <div
      style={{
        background: backgroundColor,
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        ...containerStyles,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          ...innerStyles,
        }}
      >
        {children}
      </div>
    </div>
  );
}
